import { render, staticRenderFns } from "./bulk-approve-modal.vue?vue&type=template&id=7f4f2cd2"
import script from "./bulk-approve-modal.ts?vue&type=script&lang=ts&external"
export * from "./bulk-approve-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./bulk-approve-modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f4f2cd2')) {
      api.createRecord('7f4f2cd2', component.options)
    } else {
      api.reload('7f4f2cd2', component.options)
    }
    module.hot.accept("./bulk-approve-modal.vue?vue&type=template&id=7f4f2cd2", function () {
      api.rerender('7f4f2cd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-input/bulk-approve-modal/bulk-approve-modal.vue"
export default component.exports